import { useContext } from 'react';
import { PreviewImageDataContext } from "../context/preview-image-data.js";
export const usePreviewImages = () => {
  return useContext(PreviewImageDataContext);
};
//# sourceMappingURL=use-preview-images.js.map